import axios from "axios";
import { IPassport } from "../components/passport/types";

export default {
  getBuildings(orgId, model) {
    return axios.post(
      `/efficiency/OrganizationProfile/${orgId}/Buildings`,
      model,
    );
  },

  getBuildingsForMap(request) {
    return axios.post(
      `/efficiency/OrganizationProfile/BuildingsForMap`,
      request,
    );
  },

  // getBuildings(orgId, page, count, searchText) {
  //   const data = {
  //     page: page,
  //     count: count,
  //     search: {
  //       text: searchText,
  //       fieldNames: [""],
  //     },
  //     sortItems: [
  //       {
  //         fieldName: "",
  //         direction: 0,
  //       },
  //     ],
  //     filterItems: [
  //       {
  //         fieldName: "",
  //         condition: 0,
  //         value: "",
  //       },
  //     ],
  //   };
  //   return axios.post(
  //     `/efficiency/OrganizationProfile/${orgId}/Buildings`,
  //     data,
  //   );
  // },

  getAllGetBuildings(orgId) {
    return axios.get(`/efficiency/OrganizationProfile/${orgId}/Buildings/All`);
  },
  getCurrentBuilding({ orgId, buildingId }) {
    return axios.get(
      `/efficiency/OrganizationProfile/${orgId}/Building/${buildingId}`,
    );
  },
  saveBuilding(orgId, data) {
    return axios.put(`/efficiency/OrganizationProfile/${orgId}/Building`, data);
  },
  getPassport(orgId, buildingId) {
    return axios.get<IPassport>(
      `/efficiency/OrganizationProfile/${orgId}/Building/${buildingId}/Passport`,
    );
  },
  putPassport(orgId, buildingId, data) {
    return axios.put<IPassport>(
      `/efficiency/OrganizationProfile/${orgId}/Building/${buildingId}/Passport`,
      data,
    );
  },
  getAreaHistory(buildingId, id) {
    const data = {
      page: 1,
      count: 0,
      filterItems: [
        {
          fieldName: "buildingMainId",
          condition: 0,
          value: buildingId,
        },
        {
          fieldName: "areaType",
          condition: 0,
          value: id,
        },
      ],
    };
    return axios.post(`/Orgstructure/BuildingMain/Areas`, data);
  },
  putArea(data) {
    return axios.put(`/Orgstructure/BuildingMain/Area/${data.id}`, data);
  },
  postArea(data) {
    return axios.post(`/Orgstructure/BuildingMain/Area`, data);
  },
  getRoomTypes() {
    return axios.get(`efficiency/OrganizationProfile/RoomTypes`);
  },
};
